import { inputFields, tables, Buttons } from "../../components";

const ApplicationJourney = ({ state, setState, setActiveTab }) => {
  const handleAppJourneyChange = (index, field, value) => {
    const updatedAppJourneys = [...state.appJourneys];
    updatedAppJourneys[index][field] = value;
    setState({ ...state, appJourneys: updatedAppJourneys });
  };

  const addAppJourney = () => {
    const newAppJourney = {
      title: "",
      details: "",
    };
    setState({
      ...state,
      appJourneys: [...state.appJourneys, newAppJourney],
    });
  };

  const removeAppJourney = (index) => {
    const updatedAppJourneys = state.appJourneys.filter((_, i) => i !== index);
    setState({ ...state, appJourneys: updatedAppJourneys });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleAppJourneyChange(index, "title", e.target.value)
          }
        />
      ),
    },
    {
      title: "Details",
      dataIndex: "details",
      width: 350,
      render: (text, record, index) => (
        <inputFields.DefaultTextbox
          value={text}
          onChange={(e) =>
            handleAppJourneyChange(index, "details", e.target.value)
          }
        />
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeAppJourney(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="w-[calc(100vw-20em)] overflow-x-auto max-w-full relative">
        <tables.DefaultTable
          dataSource={state.appJourneys}
          columns={columns}
          rowKey={(record, index) => index}
          pagination={false}
        />
      </div>
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton size="medium" onClick={addAppJourney}>
          Add More
        </Buttons.DefaultButton>
        <Buttons.DefaultButton size="medium" onClick={() => setActiveTab("7")}>
          Next
        </Buttons.DefaultButton>
      </div>
    </div>
  );
};

export default ApplicationJourney;
